<template>
  <component :is="component" v-if="component" :competitionKey="competitionKey" :competitionPrize="competitionPrize"></component>
</template>

<script>
export default {
  name: "AwardWriteLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    writeLayout: '',
      competitionKey:0,
      competitionPrize:0,
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/award/write/AwardWriteDefaultLayout')
        })
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.writeLayout) {
        return null
      }
      return () => import(`@/template/award/write/${this.writeLayout}`)
    },
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>
